import { render } from "./basicTable.vue?vue&type=template&id=6a661704&scoped=true"
import script from "./basicTable.vue?vue&type=script&lang=js"
export * from "./basicTable.vue?vue&type=script&lang=js"

import "./basicTable.vue?vue&type=style&index=0&id=6a661704&lang=less&scoped=true"
/* custom blocks */
import block0 from "./basicTable.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a661704"]])

export default __exports__